import React from "react";
import Fade from 'react-reveal/Fade'
import styled from "styled-components";
import Rose from '../images/RoseKamalLove.jpeg'
import Yash from '../images/YashKumarMishra.jpg'
import Nihar from '../images/NiharikaShakya.jpg'
import Nishi from '../images/NishithPandey.jpg'
import a from '../images/e.jpg'


const ClubLead = (props) => {
  return (
    <>
    <CWrapper style={{ backgroundImage: `url(${a})` }}>
    <Fade bottom>
      <Heading >Club Lead</Heading>
      </Fade>
      <RWrapper>
      <Wrapper>
      <Fade bottom>
        <RowWrapper>
        <Imag src={Rose} />
        <h4>Rose Kamal Love </h4>
        <h4>CSIT 3rd year</h4>
        </RowWrapper>
        </Fade>
      </Wrapper>

      <Wrapper>
      <Fade bottom>
        <RowWrapper>
        <Imag src={Yash} />
        <h4>Yash Kumar Mishra </h4>
        <h4>CSIT 3rd year</h4>
        </RowWrapper>
        </Fade>
      </Wrapper>

      <Wrapper>
      <Fade bottom>
        <RowWrapper>
        <Imag src={Nihar} />
        <h4>Niharika Shakya </h4>
        <h4>CSIT 3rd year</h4>
        </RowWrapper>
        </Fade>
      </Wrapper>

      <Wrapper>
      <Fade bottom>
        <RowWrapper>
        <Imag src={Nishi} />
        <h4>Nishith Pandey </h4>
        <h4>CSIT 3rd year</h4>
        </RowWrapper>
        </Fade>
      </Wrapper>
      </RWrapper>
      </CWrapper>
    </>
  );
};

export default ClubLead;

const Heading = styled.div`
    font-size : 80px;
    color : green;
`

const Wrap = styled.div `
    min-height:100vh;
    background-color: whitesmoke;
	color:white;
	background-size: cover; /* set size to cover */
	background-position: center; /* center the image */
	background-repeat: no-repeat; /* dont repeat the background */

	display: flex;
	flex-direction: row; /* switch to vertical */
	justify-content: center; /* horizontal alignment */
	align-items: center; /* vertical alignment */

	@media (max-width : 768px){
		flex-direction: column;
	}
`

const Imag = styled.img`
  border-radius : 200px;
  height : 200px;
`

const Wrapper = styled.div`
  position: relative;
  color:white;
  
  padding: 1rem;
  background: rgba(15, 14, 71, 0.3);
  box-shadow: 0px 30px 60px rgba(0, 0, 0, 0.25),
    inset 0 0 0 0.5px rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  backdrop-filter: blur(3px);
  margin: 0 auto;
`;

const RowWrapper = styled.div`
  width: 100%;
  display: flex;
	flex-direction: column; /* switch to vertical */
	justify-content: center; /* horizontal alignment */
	align-items: center; /* vertical alignment */
`;

const RWrapper = styled.div`
  width: 100%;
  display: flex;
	flex-direction: row; /* switch to vertical */
	justify-content: center; /* horizontal alignment */
	align-items: center; /* vertical alignment */

  @media (max-width : 768px){
		flex-direction: column;
	}
`;

const CWrapper = styled.div`
  width: 100%;
  min-height : 100vh;
  display: flex;
	flex-direction: column; /* switch to vertical */
	justify-content: center; /* horizontal alignment */
	align-items: center; /* vertical alignment */

`;